import util from '../util';
import Widget from './Widget';

export default class FollowerGoalWidget extends Widget {
	constructor(opts) {
		super(opts);
	}

	applySettings(settings) {
		super.applySettings(settings);
		this.setGoal(parseInt(this.settings.goal || 0) || 0);
		this._render();
	}

	_build() {
		this.container.innerHTML = `
			<div class="progressBar">
				<div class="progressAmount"></div>
				<div class="title"></div>
				<div class="progressText"></div>
				<div class="goal"></div>
			</div>
		`;
	}

	_generateCSS() {
		const s = this.settings;
		const valign = { top: 'flex-start', middle: 'center', bottom: 'flex-end' }[s.verticalAlign] || 'center';
		const css = `
			#${this.container.id} {
				height: 100%;
				display: flex;
				flex-direction: column;
				justify-content: ${valign};
				font-family: Arial, sans-serif;
				color: ${s.textColor || '#ffffff'};
				${s.fontFamily ? `font-family: '${s.fontFamily}';` : ''}
				font-size: ${s.fontSize || 40}px;
				${s.letterSpacing > 0 ? `letter-spacing: ${s.letterSpacing}px;` : ''}
				${s.boldText ? 'font-weight: bold;' : ''}
				${s.italicText ? 'font-style: italic;' : ''}
				${(s.underlineText || s.strikethroughText) ? `text-decoration: ${s.underlineText ? 'underline' : ''} ${s.strikethroughText ? 'line-through' : ''};` : ''}
				${s.uppercaseText ? 'text-transform: uppercase;' : ''}
			}
			#${this.container.id} > .progressBar {
				z-index: 0;
				position: relative;
				display: flex;
				justify-content: space-between;
				background-color: ${s.backColor || '#000000'};
				background-clip: padding-box;
				${s.borderRadius > 0 ? `border-radius: ${s.borderRadius}px;` : ''}
				overflow: hidden;
				${s.borderWidth > 0 && s.borderColor ? `border: ${s.borderWidth}px solid ${s.borderColor};` : ''}
				${s.padding > 0 ? `padding: ${s.padding}px;` : ''}
			}
			#${this.container.id} > .progressBar > .progressAmount {
				z-index: 1;
				position: absolute;
				left: 0; top: 0; bottom: 0;
				width: 0%;
				background-color: ${s.barColor || '#007fff'};
				${s.stripes ? `
				background-image: linear-gradient(-60deg, rgba(255,255,255,.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,.15) 50%, rgba(255,255,255,.15) 75%, transparent 75%, transparent);
				background-size: 46px 80px;
				animation: progressBarStripes 2s linear infinite;
				` : ''}
				transition: width .5s ease-in-out;
			}
			@keyframes progressBarStripes {
				from { background-position: 46px 0; }
				to   { background-position: 0 0; }
			}
			#${this.container.id} > .progressBar > .progressText {
				z-index: 3;
				${(s.blurRadius > 0 || s.spreadRadius > 0) ? `filter: ${util.generateSpreadShadowFilter(s.spreadRadius, s.blurRadius, s.shadowColor)};` : ''}
			}
			#${this.container.id} > .progressBar > .title {
				white-space: pre;
				z-index: 2;
				${(s.blurRadius > 0 || s.spreadRadius > 0) ? `filter: ${util.generateSpreadShadowFilter(s.spreadRadius, s.blurRadius, s.shadowColor)};` : ''}
			}
			#${this.container.id} > .progressBar > .goal {
				z-index: 4;
				${(s.blurRadius > 0 || s.spreadRadius > 0) ? `filter: ${util.generateSpreadShadowFilter(s.spreadRadius, s.blurRadius, s.shadowColor)};` : ''}
			}
			${s.extraCSS || ''}
		`;
		this._setCSS('followerGoalWidgetStyle', css);
		this._updateFontLink();
	}

	setGoal(goal) {
		this._goal = goal;
		this._render();
	}

	_render() {
		if(!this.settings) return;
		const progressAmountEl = this.container.querySelector('.progressAmount');
		if(!progressAmountEl) return;

		const total = parseInt(this.settings.count || 0) || 0;
		const goal  = this._goal || 0;
		const pct   = goal ? Math.round(Math.min(total, goal) / goal * 100) : 0;

		progressAmountEl.style.width = `${pct}%`;

		const titleEl        = this.container.querySelector('.title');
		const progressTextEl = this.container.querySelector('.progressText');
		const goalEl         = this.container.querySelector('.goal');

		if(titleEl) titleEl.innerText = this.settings.title || '';
		if(progressTextEl) progressTextEl.innerText = this.settings.hidePercentage ? String(total) : `${total} (${pct}%)`;
		if(goalEl) goalEl.innerText = goal ? String(goal) : '';
	}
}
